import { DateRangeValidationError } from '@mui/x-date-pickers-pro';
import { basicErrorHandling } from 'common/components/Inputs/DateRangePickerMui/DateRangePickerMui.util.ts';

export const getValidDateRange = <
  T extends { uploadDateFrom: Date | null; uploadDateTo: Date | null },
>(
  err: DateRangeValidationError,
  prevFilters: T,
) => {
  if (
    (prevFilters.uploadDateFrom && err[0] === null) ||
    (prevFilters.uploadDateTo && err[1] === null)
  ) {
    const validRange = basicErrorHandling(
      [prevFilters.uploadDateFrom, prevFilters.uploadDateTo],
      err,
    );
    return {
      ...prevFilters,
      uploadDateFrom: validRange[0],
      uploadDateTo: validRange[1],
    };
  }

  return prevFilters;
};
